<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="3000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="self_apprisal_link_list"
        dense
        class="elevation-1 mytable"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title
              >Apprisal Authority Type Faculty Post Linking</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"> </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small
                  >Add Faculty Post</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          v-if="editedIndex == -1"
                        >
                          <v-autocomplete
                            rounded
                            dense
                            required
                            v-model="faculty_post"
                            :items="faculty_post_list"
                            item-text="faculty_post"
                            item-value="faculty_id"
                            label="Faculty Post"
                            outlined
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          v-if="editedIndex != -1"
                        >
                          <v-autocomplete
                            v-model="editedItem.faculty_post"
                            :items="faculty_post_list"
                            item-text="faculty_post"
                            rounded
                            dense
                            required
                            label="Faculty Post"
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          v-if="editedIndex == -1"
                        >
                          <v-autocomplete
                            rounded
                            dense
                            required
                            v-model="self_auth_name"
                            :items="apprisal_auth_type_list"
                            item-text="self_auth_name"
                            item-value="self_apprisal_id"
                            label="Apprisal Authority Type"
                            outlined
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          v-if="editedIndex != -1"
                        >
                          <v-autocomplete
                            rounded
                            dense
                            required
                            v-model="editedItem.self_auth_name"
                            :items="apprisal_auth_type_list"
                            item-text="self_auth_name" 
                            label="Apprisal Authority Type"
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2  v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2  v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template>
      </v-data-table>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    self_auth_name: null,
    faculty_post: null,
    headers: [
      {
        text: "Faculty Post",
        align: "left",
        sortable: false,
        value: "faculty_post",
      },

      {
        text: "Apprisal Authoity Type",
        align: "left",
        sortable: false,
        value: "self_auth_name",
      },

      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      {
        text: "Actions",
        value: "action",
        sortable: false,
      },
    ],
    faculty_post_list: [],
    apprisal_auth_type_list: [],
    self_apprisal_link_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      faculty_post: "",
      self_auth_name: "",
      faculty_id: "",
      self_apprisal_id : "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      faculty_post: "",
      self_auth_name: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Authority Type Post Linking"
        : "Edit Authority Type Post Linking";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.event_type = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/SelfAppraisal/getAuthTypePostLinkingMaster")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.faculty_post_list = res.data.faculty_post_list;
            this.apprisal_auth_type_list = res.data.apprisal_auth_type_list;
            this.self_apprisal_link_list = res.data.self_apprisal_link_list;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.self_apprisal_link_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      //alert(JSON.stringify(this.editedItem));
      this.dialog = true;
    },

    close() {
      (this.self_auth_name = null),
        (this.faculty_post = null),
        (this.dialog = false);
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post(
              "/SelfAppraisal/editAuthTypePostLinkingMaster",
              this.editedItem
            )
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.self_apprisal_link_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Authority Type Post Linking Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Authority Type Post Linking Already Present!!!"
                ); // show snackbar on error
              }
              this.onLoad();
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.onLoad();
          this.close();
        }
      } else {
        if (this.faculty_post == null) {
          this.showSnackbar("#b71c1c", "Please Enter All Fieldst!!!");
        } else if (this.self_auth_name == null) {
          textthis.showSnackbar("#b71c1c", "Please Enter All Fieldst!!!");
        } else {
          const formData = {
            faculty_post: this.faculty_post,
            self_auth_name: this.self_auth_name,
            isactive: this.isactive,
          };
          axios
            .post("/SelfAppraisal/saveAuthTypePostLinkingMaster", formData)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.self_apprisal_link_list.push(this.editedItem);
                this.showSnackbar(
                  "#4caf50",
                  "Authority Type Post Linking Added Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Authority Type Post Linking Already Present!!!"
                ); // show snackbar on error
              }
              this.onLoad();
            })
            .catch((error) => {
              window.console.log(error);
            });
        }
        this.onLoad();
        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.self_auth_name && this.editedItem.faculty_post) {
        return true;
      } else {
        //alert("false");
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
